import { mapGetters, mapActions } from 'vuex';
import { required, email, minLength, sameAs } from "vuelidate/lib/validators";

export default {
  components: {
  },
  data() {
    return {
      user: {
        nom: '',
        prenom: '',
        email: '',
        societe: '',
        telephone: '',
        password: '',
        password_confirmation: '',
        rgpd: false,
      },
      credentials: {
        user: '',
        password: '',
      },
      errors : '',
      breadcrumb: [],
      article: {
        page: {
          pictures: [],
        }
      },
      imageSelected: null,
      nextSibling: null,
      previousSibling: null,
      csrf: 'vide',
      submitted: false,
      badCredentials: false,
      passwordType: 'password',
      loading:false
    }
  },

  validations() {
    return {
      user: {
        nom: { required, minLength: minLength(3) },
        prenom: { required, minLength: minLength(3) },
        societe: { required },
        telephone: {required},
        password: { required },
        password_confirmation: { sameAsPassword: sameAs('password') },
        email: { required, email },
      }
    }
  },

  computed: {
    ...mapGetters([
      'auth',
    ]),
  },

  methods: {

    ...mapActions([
      'register',
      'connectAccess',
    ]),

    sendRegister() {
      this.errors = '';
      this.submitted = true;

      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.$invalid) {
          return;
      }
      this.register(this.user).then(response => {
        this.$refs.registerConfirmation.show();
      }).catch(error => {
        for(let property in error.response.data.errors){
          this.errors = ' '+error.response.data.errors[property][0];
        }
      });;
    },

    connect() {
      this.loading = true
      this.badCredentials = false;
      this.connectAccess(this.credentials).then(response => {
        this.loading = false
        this.$router.push('/envoyer-courrier');
      }).catch(error => {
        this.loading = false
        this.badCredentials = true;
      });
    },

    connectAuto() {
      this.credentials.user = this.user.email;
      this.credentials.password = this.user.password;
      this.connect();
    },

    changePasswordType() {
      if (this.passwordType == 'password') {
        this.passwordType = 'text';
      } else {
        this.passwordType = 'password';
      }
    },

  },

  mounted() {
    if (this.auth.user) {
      this.$router.push('/envoyer-courrier')
    }
  },

  updated() {

  },


}